import { PropsWithChildren } from 'react';

import { Text } from '@spotify-internal/encore-web';

import { TopRightSwirlArrowIcon } from '../Icons';

import styles from './SectionEmptyState.module.css';

type SectionEmptyStateProps = PropsWithChildren<{
  title?: string;
  description?: string;
  hideArrow?: boolean;
}>;

export const SectionEmptyState = ({
  title,
  description,
  children,
  hideArrow = false,
}: SectionEmptyStateProps) => (
  <div className={styles.root}>
    {!hideArrow && (
      <span className={styles.arrow}>
        <TopRightSwirlArrowIcon size={128} />
      </span>
    )}
    <div className={styles.content}>
      {title && (
        <Text as="h6" variant="titleExtraSmall">
          {title}
        </Text>
      )}
      {description && (
        <Text as="p" variant="bodyMedium">
          {description}
        </Text>
      )}
    </div>
    {children}
  </div>
);
